<template>
    <div class="page-container">
        <div class="card-box">
            <div class="card-title">经销商名片</div>
            <div class="card-content-wrapper">
                <div class="card-content">
                    <div class="business-name">{{userInfo.userName}}</div>
                    <div class="content-text">您已成为御粮世家全国经销商，在此范围内可享受经销商的所有奖励和优惠政策。</div>
                </div>
                <div class="card-bottom">
                    <div class="bottom-left">
                        <div class="company">公司：广东御粮世家有限公司</div>
                        <!-- <div class="date">日期：2020年11月12日</div> -->
                    </div>
                    <img src="../../assets/level-icon-1.png" v-if="userInfo.level == 2" class="level-icon" />
                    <img src="../../assets/level-icon-2.png" v-if="userInfo.level == 3 || userInfo.level == 4" class="level-icon" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import $http from '@/lib/request'
import config from '@/config'
import { setLocalUserInfo } from '@/lib/util'

export default {
    data(){
        return {
            userInfo:{},//userInfo.level:1 潜在合伙人，2 初级合伙人，3 高级合伙人，4 战略合伙人
        }
    },
    activated(){
        this.checkuData();
    },
    methods:{
        checkuData(){//获取最新用户信息
            $http({
                method:'post',
                url:config.api.checkUserData
            }).then(res=>{
                if(res.errno == 0){
                    this.userInfo=res.data;
                    setLocalUserInfo(res.data);
                }else{
                    Toast(res.errmsg)
                }
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.page-container{
    padding-top: 50px;
    box-sizing: border-box;
    height:100vh;
    background: linear-gradient(110deg, #3CA7FE 0%, #3088F5 100%);
    .card-box{
        width:355px;
        height:453px;
        background: url('../../assets/business-card-bg.png') no-repeat center center;
        background-size: 355px 453px;
        overflow: hidden;
        margin:0 auto;
        .card-title{
            margin-top: 97px;
            font-size: 22px;
            line-height: 30px;
            color:#333;
            text-align: center;
        }
        .card-content-wrapper{
            margin-top: 45px;
            margin-left: 40px;
            width:272px;
            .card-content{
                margin-bottom: 44px;
                .business-name{
                    padding:0 6px;
                    line-height: 28px;
                    display: inline-block;
                    color:#333;
                    border-bottom: 1px solid #3088F5;
                    margin-bottom: 14px;
                }
                .content-text{
                    color:#333;
                    font-size: 13px;
                    line-height: 18px;
                }
            }
            .card-bottom{
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
                .bottom-left{
                    color:#333;
                    line-height: 18px;
                    font-size: 13px;
                    .company{
                        margin-bottom: 10px;
                    }
                }
                .level-icon{
                    width:79px;
                    height:73px;
                }
            }
        }
    }
}
</style>